import { createSelector } from 'reselect';
import PredesComplianceMessageMappingErrorsKeyDetailsColumns
  from '../../containers/PredesComplianceMessageMappingErrorsKeyDetailsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_KEY_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_KEY_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_KEY_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceMessageMappingErrorsKeyDetailsColumns);
